__webpack_require__.p = "/mi-assets/mi-static/mi-homepage-renderer/web-rel-26.5.1-27a90e5-9935/_next/";